import styled from 'styled-components';

export const H3 = styled.h3`
  font-size: 26px;
  padding-left: 12px;
  margin-top: 20px;
  margin-bottom: 20px;
`;
